import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrQuickOrderHistroyComponent } from './kn-br-quick-order-histroy.component';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule, ListNavigationModule, SpinnerModule } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { KnBrCustomPipesModule } from 'src/app/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        I18nModule,
        FormErrorsModule,
        NgbModule,
        SpinnerModule,
        ListNavigationModule,
        KnBrCustomPipesModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBr360OrderHistoryComponent: {
                    component: () => import('./kn-br-quick-order-histroy.component').then((c) => c.KnBrQuickOrderHistroyComponent),
                },
            },
        } as CmsConfig),
        KnBrQuickOrderHistroyComponent,
    ],
})
export class KnBrQuickOrderHistroyModule {}
